export const styleCss: string = `.remittance-document {
  font-family: Arial, Helvetica, sans-serif;
}

.remittance-document .body-section {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.remittance-header {
  font-size: 2em;
  font-weight: bold;
margin-top: 20px;
margin-bottom: 10px;
}

.body-section {
  margin-top: 40px;
}

.company-name {
  font-size: 1.5em;
margin-top: 10px;
margin-bottom: 10px;
}

.remittance-document .header-section {
  width: 100%;
  text-align: center;
}

.remittance-document .header {
  font-weight: bold;
}

table {
  border-collapse: collapse;
}

.document-section thead th {
  border-bottom: solid 1px;
  text-align: left;
}

.document-section tbody tr td {
padding-top: 3px;
padding-bottom: 3px;
}

.document-section tfoot tr {
  border-top: solid 1px;
  font-weight: bold;
}

.document-section tfoot tr td {
  padding-top: 3px;
}

.payments-section {
  border-top: solid 1px;
  border-bottom: solid 1px;
}

.address-section {
  flex: 0 50%;
}

.remittance-section {
  padding-top: 0px;
  flex: 0 50%;
}
.address-section .row {
padding-top: 3px;
padding-bottom: 3px;
}

.remittance-section .row {
  flex: 0 100%;
  display: flex;
  flex-direction: row;
padding-top: 3px;
padding-bottom: 3px;
}

.remittance-section .row div {
  flex: 0 50%;
}

.remittance-section .row div.value {
  text-align: right;
  margin-right: 0px;
}


.remittance-section thead tr th {
  width: 25%;
}
.remittance-section tbody tr td {
  width: 25%;
padding-top: 3px;
padding-bottom: 3px;
}


.document-section {
  margin-top: 40px;
  flex: 0 100%;
}


.payments-section thead th {
  text-align: left;
padding-top: 3px;
padding-bottom: 3px;
}
.payments-section th {
  width: 25%;
}


.payments-section tbody tr td {
  padding-top: 3px;
padding-bottom: 3px;
}

.payments-section {
  margin-top: 40px;
  flex: 0 100%;
}

.remittance-document table {
  width: 100%;
}

`;
